module.exports = __webpack_public_path__ + "img/26.4cbf2e81.png";